
import { useState } from 'react';

export const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'What is a VPN and how does DUVANKA VPN work?',
      answer: 'A VPN (Virtual Private Network) creates a secure, encrypted connection between your device and our servers. DUVANKA VPN routes your internet traffic through our secure servers, hiding your IP address and encrypting your data to protect your privacy and security online.'
    },
    {
      question: 'What security features does DUVANKA VPN provide?',
      answer: 'DUVANKA VPN uses military-grade AES-256 encryption, maintains a strict no-logs policy, includes an automatic kill switch, offers split tunneling capabilities, and provides DNS leak protection to ensure your online activities remain completely private and secure.'
    },
    {
      question: 'Which devices are compatible with DUVANKA VPN?',
      answer: 'DUVANKA VPN supports all major platforms including Windows, macOS, iOS, Android, and Linux. You can protect unlimited devices simultaneously with a single account, ensuring all your digital activities remain secure across all platforms.'
    },
    {
      question: 'How do I connect to DUVANKA VPN servers?',
      answer: 'Simply download the DUVANKA VPN app for your device, create an account, and choose from our global network of servers. The app features a user-friendly interface that allows you to connect with just one click, automatically selecting the best server for optimal performance.'
    },
    {
      question: 'Does DUVANKA VPN keep logs of user activities?',
      answer: 'No, DUVANKA VPN maintains a strict zero-logs policy. We do not track, collect, store, or share any information about your online activities, ensuring complete privacy and anonymity while using our service.'
    },
    {
      question: 'How can I get technical support for DUVANKA VPN?',
      answer: 'Our technical support team is available via email at support@duvankadoo.com or by phone at +1 3256664206. We provide comprehensive support to help you with installation, configuration, troubleshooting, and any questions about our VPN service.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl md:text-5xl font-serif text-navy-900 mb-6">
            Frequently Asked Questions
          </h3>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Find answers to common questions about DUVANKA VPN and our security features.
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <button
                className="w-full p-6 text-left flex items-center justify-between cursor-pointer"
                onClick={() => toggleFAQ(index)}
              >
                <h4 className="text-lg font-bold text-navy-900 pr-4">
                  {faq.question}
                </h4>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-xl text-cyan-600 transition-transform duration-300`}></i>
                </div>
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-6">
                  <div className="pt-4 border-t border-gray-100">
                    <p className="text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
